import { Theme } from '@mui/material/styles'

const muiContainer = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        position: 'relative',
        margin: '0px auto',
        //todo: why is this here?
        '@media(min-width:2560px)': {
          maxWidth: '80%'
        },
        '@media(max-width:2560px)': {
          maxWidth: 1820
        },
        '@media(max-width:1920px)': {
          maxWidth: 1570
        },
        '@media(max-width:1800px)': {
          maxWidth: 1440
        },
        '@media(max-width:1660px)': {
          maxWidth: 1280
        },
        '@media(max-width:1440px)': {
          maxWidth: 1170
        },
        '@media(max-width:1368px)': {
          maxWidth: 1110
        },
        '@media(min-width:600px)': {
          paddingLeft: 0,
          paddingRight: 0
        }
      }
    }
  }
}

export default muiContainer
